import 'normalize.css';
import 'fonts/inter/inter.css';
import 'styles/global.css';

console.log(
  '%c👨‍💻 Site by Lukas Romsicki | https://romsicki.com',
  'font-size: 10px; font-weight: bold; color: #fff; background-color: #0D5583; padding:6px; border-radius: 5px;'
);
